// AUTO-GENERATED (gen_coop_i18n.py). Chicken coop size calculator, 22 languages.
export const COOP_GEN = {
 "fr": {
  "slug": "calculateur-taille-poulailler",
  "title": "Calculateur de taille de poulailler | Ma Petite Ferme",
  "metaDescription": "Calculez gratuitement la taille de poulailler idéale pour vos poules : surface abri, surface parcours, nombre de nichoirs et longueur de perchoir.",
  "h1": "Calculateur de taille de poulailler",
  "intro": "Indiquez votre nombre de poules pour obtenir les dimensions recommandées : surface de l'abri, surface du parcours, nombre de nichoirs et longueur de perchoir.",
  "hens": "Nombre de poules",
  "resultTitle": "Recommandations",
  "coopArea": "Surface de l'abri",
  "runArea": "Surface du parcours",
  "nestBoxes": "Nombre de nichoirs",
  "perchLength": "Longueur de perchoir",
  "m2Unit": "m²",
  "mUnit": "m",
  "disclaimer": "Recommandations indicatives basées sur les bonnes pratiques d'élevage (env. 3 poules/m² d'abri, 2,5 m²/poule de parcours, 1 nichoir pour 4 poules, 20 cm de perchoir/poule).",
  "ctaTitle": "Gérez votre élevage avec Ma Petite Ferme",
  "ctaText": "Suivez votre cheptel, vos pontes et votre production au quotidien, en toute simplicité.",
  "ctaBtn": "Créer ma ferme gratuitement"
 },
 "es": {
  "slug": "calculadora-tamano-gallinero",
  "title": "Calculadora de tamaño de gallinero | Ma Petite Ferme",
  "metaDescription": "Calcula gratis el tamaño ideal de tu gallinero: superficie del refugio, zona de campeo, número de ponederos y longitud de perchas para tus gallinas.",
  "h1": "Calculadora de tamaño de gallinero",
  "intro": "Indica tu número de gallinas para obtener las dimensiones recomendadas: superficie del refugio, zona de campeo, número de ponederos y longitud de perchas.",
  "hens": "Número de gallinas",
  "resultTitle": "Recomendaciones",
  "coopArea": "Superficie del refugio",
  "runArea": "Superficie de campeo",
  "nestBoxes": "Número de ponederos",
  "perchLength": "Longitud de perchas",
  "m2Unit": "m²",
  "mUnit": "m",
  "disclaimer": "Recomendaciones orientativas basadas en buenas prácticas de cría (aprox. 3 gallinas/m² de refugio, 2,5 m²/gallina de campeo, 1 ponedero por cada 4 gallinas, 20 cm de percha/gallina).",
  "ctaTitle": "Gestiona tu cría con Ma Petite Ferme",
  "ctaText": "Lleva el seguimiento de tu rebaño, las puestas y tu producción día a día, de forma sencilla.",
  "ctaBtn": "Crear mi granja gratis"
 },
 "en": {
  "slug": "chicken-coop-size-calculator",
  "title": "Chicken Coop Size Calculator | Ma Petite Ferme",
  "metaDescription": "Free chicken coop size calculator: find the ideal coop area, run space, nest boxes and perch length for your flock in seconds.",
  "h1": "Chicken Coop Size Calculator",
  "intro": "Enter your number of hens to get tailored recommendations: coop floor area, outdoor run space, number of nest boxes and total perch length.",
  "hens": "Number of hens",
  "resultTitle": "Recommendations",
  "coopArea": "Coop floor area",
  "runArea": "Outdoor run area",
  "nestBoxes": "Number of nest boxes",
  "perchLength": "Total perch length",
  "m2Unit": "sq ft",
  "mUnit": "ft",
  "disclaimer": "Indicative recommendations based on standard poultry-keeping guidelines (approx. 3 hens per sq m of coop, 2.5 sq m of run per hen, 1 nest box per 4 hens, 20 cm of perch per hen).",
  "ctaTitle": "Manage Your Flock with Ma Petite Ferme",
  "ctaText": "Track your hens, egg production and daily farm activity — all in one simple place.",
  "ctaBtn": "Create my farm for free"
 },
 "it": {
  "slug": "calcolatore-dimensioni-pollaio",
  "title": "Calcolatore dimensioni pollaio | Ma Petite Ferme",
  "metaDescription": "Calcola gratis le dimensioni ideali del tuo pollaio: superficie riparo, area di razzolamento, numero di nidi e lunghezza dei trespoli.",
  "h1": "Calcolatore dimensioni pollaio",
  "intro": "Indica il numero di galline per ottenere le dimensioni consigliate: superficie del riparo, area di razzolamento, numero di nidi e lunghezza dei trespoli.",
  "hens": "Numero di galline",
  "resultTitle": "Raccomandazioni",
  "coopArea": "Superficie del riparo",
  "runArea": "Area di razzolamento",
  "nestBoxes": "Numero di nidi",
  "perchLength": "Lunghezza dei trespoli",
  "m2Unit": "m²",
  "mUnit": "m",
  "disclaimer": "Raccomandazioni indicative basate sulle buone pratiche di allevamento (circa 3 galline/m² nel riparo, 2,5 m²/gallina di razzolamento, 1 nido ogni 4 galline, 20 cm di trespolo per gallina).",
  "ctaTitle": "Gestisci il tuo allevamento con Ma Petite Ferme",
  "ctaText": "Tieni traccia del tuo gregge, delle uova deposte e della produzione quotidiana, in tutta semplicità.",
  "ctaBtn": "Crea la mia fattoria gratuitamente"
 },
 "nl": {
  "slug": "calculator-kippenren-grootte",
  "title": "Calculator kippenren grootte | Ma Petite Ferme",
  "metaDescription": "Bereken gratis de ideale grootte van uw kippenren: oppervlakte nachthok, uitloop, aantal legnesten en zitstoklengte voor uw kippen.",
  "h1": "Calculator kippenren grootte",
  "intro": "Geef het aantal kippen op om de aanbevolen afmetingen te berekenen: oppervlakte van het nachthok, uitloopoppervlakte, aantal legnesten en lengte van de zitstok.",
  "hens": "Aantal kippen",
  "resultTitle": "Aanbevelingen",
  "coopArea": "Oppervlakte nachthok",
  "runArea": "Oppervlakte uitloop",
  "nestBoxes": "Aantal legnesten",
  "perchLength": "Lengte zitstok",
  "m2Unit": "m²",
  "mUnit": "m",
  "disclaimer": "Indicatieve aanbevelingen op basis van goede houderijpraktijken (ca. 3 kippen/m² nachthok, 2,5 m²/kip uitloop, 1 legnest per 4 kippen, 20 cm zitstok per kip).",
  "ctaTitle": "Beheer uw kippenhok met Ma Petite Ferme",
  "ctaText": "Volg uw kudde, de eileg en uw dagelijkse productie eenvoudig en overzichtelijk bij.",
  "ctaBtn": "Maak mijn boerderij gratis aan"
 },
 "sv": {
  "slug": "kalkylator-honshusstorlek",
  "title": "Kalkylator för hönshus storlek | Ma Petite Ferme",
  "metaDescription": "Beräkna gratis rätt storlek på ditt hönshus: yta för stallet, rastgårdsyta, antal värpbon och sittpinnelängd för dina höns.",
  "h1": "Kalkylator för hönshus storlek",
  "intro": "Ange ditt antal höns för att få rekommenderade mått: yta för stallet, rastgårdsyta, antal värpbon och sittpinnelängd.",
  "hens": "Antal höns",
  "resultTitle": "Rekommendationer",
  "coopArea": "Stallyta",
  "runArea": "Rastgårdsyta",
  "nestBoxes": "Antal värpbon",
  "perchLength": "Sittpinnelängd",
  "m2Unit": "m²",
  "mUnit": "m",
  "disclaimer": "Vägledande rekommendationer baserade på god uppfödningspraxis (ca 3 höns/m² i stallet, 2,5 m²/höna i rastgården, 1 värpbo per 4 höns, 20 cm sittpinne per höna).",
  "ctaTitle": "Sköt ditt hönshus med Ma Petite Ferme",
  "ctaText": "Följ dina höns, äggproduktion och daglig skötsel enkelt och smidigt.",
  "ctaBtn": "Skapa min gård gratis"
 },
 "de": {
  "slug": "huehnerstall-groesse-berechnen",
  "title": "Hühnerstall Größenrechner | Ma Petite Ferme",
  "metaDescription": "Berechnen Sie kostenlos die ideale Hühnerstallgröße: Stallfläche, Auslauf, Anzahl Legenester und Sitzstangenlänge für Ihre Hühner.",
  "h1": "Hühnerstall Größenrechner",
  "intro": "Geben Sie Ihre Hühneranzahl ein und erhalten Sie die empfohlenen Maße: Stallfläche, Auslauffläche, Anzahl der Legenester und Länge der Sitzstange.",
  "hens": "Anzahl Hühner",
  "resultTitle": "Empfehlungen",
  "coopArea": "Stallfläche",
  "runArea": "Auslauffläche",
  "nestBoxes": "Anzahl Legenester",
  "perchLength": "Sitzstangenlänge",
  "m2Unit": "m²",
  "mUnit": "m",
  "disclaimer": "Richtwerte basierend auf bewährten Haltungsempfehlungen (ca. 3 Hühner/m² Stallfläche, 2,5 m² Auslauf/Huhn, 1 Legenest für 4 Hühner, 20 cm Sitzstange/Huhn).",
  "ctaTitle": "Verwalten Sie Ihre Hühnerhaltung mit Ma Petite Ferme",
  "ctaText": "Behalten Sie Ihren Bestand, Ihre Legeleistung und Ihre tägliche Produktion ganz einfach im Blick.",
  "ctaBtn": "Meine Farm kostenlos erstellen"
 },
 "da": {
  "slug": "beregner-honsehus-storrelse",
  "title": "Beregner til hønsehusets størrelse | Ma Petite Ferme",
  "metaDescription": "Beregn gratis den ideelle størrelse på dit hønsehus: staldareal, løbeareal, antal reder og siddepindens længde til dine høns.",
  "h1": "Beregner til hønsehusets størrelse",
  "intro": "Angiv dit antal høns for at få de anbefalede mål: staldareal, løbeareal, antal reder og siddepindens længde.",
  "hens": "Antal høns",
  "resultTitle": "Anbefalinger",
  "coopArea": "Staldareal",
  "runArea": "Løbeareal",
  "nestBoxes": "Antal reder",
  "perchLength": "Siddepindens længde",
  "m2Unit": "m²",
  "mUnit": "m",
  "disclaimer": "Vejledende anbefalinger baseret på god opdrætspraksis (ca. 3 høns/m² i stalden, 2,5 m² løbeareal pr. høne, 1 rede per 4 høns, 20 cm siddepind pr. høne).",
  "ctaTitle": "Administrer dit hold med Ma Petite Ferme",
  "ctaText": "Følg din besætning, æglægningen og din daglige produktion på en enkel og overskuelig måde.",
  "ctaBtn": "Opret min farm gratis"
 },
 "bg": {
  "slug": "kalkulator-razmer-kokosha-kushta",
  "title": "Калкулатор за размер на кокошарник | Ma Petite Ferme",
  "metaDescription": "Изчислете безплатно идеалния размер на кокошарника си: площ на убежището, двор, брой гнезда и дължина на кацалката.",
  "h1": "Калкулатор за размер на кокошарник",
  "intro": "Въведете броя на кокошките си, за да получите препоръчителните размери: площ на убежището, площ на двора, брой гнезда и дължина на кацалката.",
  "hens": "Брой кокошки",
  "resultTitle": "Препоръки",
  "coopArea": "Площ на убежището",
  "runArea": "Площ на двора",
  "nestBoxes": "Брой гнезда",
  "perchLength": "Дължина на кацалката",
  "m2Unit": "м²",
  "mUnit": "м",
  "disclaimer": "Ориентировъчни препоръки, базирани на добрите практики в животновъдството (около 3 кокошки/м² в убежището, 2,5 м²/кокошка двор, 1 гнездо на 4 кокошки, 20 см кацалка/кокошка).",
  "ctaTitle": "Управлявайте отглеждането си с Ma Petite Ferme",
  "ctaText": "Следете стадото си, снасянето и производството си всеки ден, бързо и лесно.",
  "ctaBtn": "Създайте фермата си безплатно"
 },
 "hr": {
  "slug": "kalkulator-velicine-kokosinjca",
  "title": "Kalkulator veličine kokošinjca | Ma Petite Ferme",
  "metaDescription": "Besplatno izračunajte idealnu veličinu kokošinjca: površina skloništa, ispusta, broj gnijezdilica i dužina sjedala za vaše kokoši.",
  "h1": "Kalkulator veličine kokošinjca",
  "intro": "Unesite broj kokoši kako biste dobili preporučene dimenzije: površina kokošinjca, površina ispusta, broj gnijezdilica i dužina sjedala.",
  "hens": "Broj kokoši",
  "resultTitle": "Preporuke",
  "coopArea": "Površina kokošinjca",
  "runArea": "Površina ispusta",
  "nestBoxes": "Broj gnijezdilica",
  "perchLength": "Dužina sjedala",
  "m2Unit": "m²",
  "mUnit": "m",
  "disclaimer": "Okvirne preporuke temeljene na dobrim praksama uzgoja (oko 3 kokoši/m² kokošinjca, 2,5 m²/kokoši ispusta, 1 gnijezdilica na 4 kokoši, 20 cm sjedala po kokoši).",
  "ctaTitle": "Upravljajte svojim uzgojem uz Ma Petite Ferme",
  "ctaText": "Pratite svoje stado, nošenje jaja i svakodnevnu proizvodnju na jednostavan način.",
  "ctaBtn": "Besplatno kreirajte svoju farmu"
 },
 "et": {
  "slug": "kanatalli-suuruse-kalkulaator",
  "title": "Kanatalli suuruse kalkulaator | Ma Petite Ferme",
  "metaDescription": "Arvuta tasuta oma kanade jaoks ideaalne kanatalli suurus: varjualuse pindala, aediku pindala, pesakastide arv ja orsi pikkus.",
  "h1": "Kanatalli suuruse kalkulaator",
  "intro": "Sisestage kanade arv, et saada soovituslikud mõõtmed: varjualuse pindala, aediku pindala, pesakastide arv ja orsi pikkus.",
  "hens": "Kanade arv",
  "resultTitle": "Soovitused",
  "coopArea": "Varjualuse pindala",
  "runArea": "Aediku pindala",
  "nestBoxes": "Pesakastide arv",
  "perchLength": "Orsi pikkus",
  "m2Unit": "m²",
  "mUnit": "m",
  "disclaimer": "Soovituslikud näidud, mis põhinevad headel peetavuspraktikatel (u. 3 kana/m² varjualuses, 2,5 m² kana kohta aedikus, 1 pesakast 4 kana kohta, 20 cm orsi kana kohta).",
  "ctaTitle": "Halda oma linnukasvatust Ma Petite Ferme'iga",
  "ctaText": "Jälgi oma karju, munemist ja igapäevast toodangut lihtsalt ja mugavalt.",
  "ctaBtn": "Loo oma farm tasuta"
 },
 "el": {
  "slug": "ypologistis-megethous-kotetsiou",
  "title": "Υπολογιστής μεγέθους κοτετσιού | Ma Petite Ferme",
  "metaDescription": "Υπολογίστε δωρεάν το ιδανικό μέγεθος κοτετσιού για τις κότες σας: χώρος καταφυγίου, αυλή, φωλιές και κούρνιες.",
  "h1": "Υπολογιστής μεγέθους κοτετσιού",
  "intro": "Εισάγετε τον αριθμό των κοτών σας για να λάβετε τις προτεινόμενες διαστάσεις: επιφάνεια καταφυγίου, επιφάνεια αυλής, αριθμός φωλιών και μήκος κούρνιας.",
  "hens": "Αριθμός κοτών",
  "resultTitle": "Προτάσεις",
  "coopArea": "Επιφάνεια καταφυγίου",
  "runArea": "Επιφάνεια αυλής",
  "nestBoxes": "Αριθμός φωλιών",
  "perchLength": "Μήκος κούρνιας",
  "m2Unit": "τ.μ.",
  "mUnit": "μ.",
  "disclaimer": "Ενδεικτικές προτάσεις βάσει ορθών πρακτικών εκτροφής (περίπου 3 κότες/τ.μ. καταφυγίου, 2,5 τ.μ./κότα αυλής, 1 φωλιά για 4 κότες, 20 εκ. κούρνιας/κότα).",
  "ctaTitle": "Διαχειριστείτε την εκτροφή σας με το Ma Petite Ferme",
  "ctaText": "Παρακολουθήστε το κοπάδι σας, τα αυγά και την παραγωγή σας καθημερινά, με απλό και εύκολο τρόπο.",
  "ctaBtn": "Δημιουργήστε τη φάρμα μου δωρεάν"
 },
 "fi": {
  "slug": "kanalantarha-kokolaskuri",
  "title": "Kanalantarha-kokolaskuri | Ma Petite Ferme",
  "metaDescription": "Laske ilmaiseksi kanalallesi sopiva koko: suoja-ala, ulkotarha, pesäpönttöjen määrä ja orren pituus juuri sinun kanoillesi.",
  "h1": "Kanalantarha-kokolaskuri",
  "intro": "Syötä kanojen lukumäärä ja saat suositellut mitat: suoja-alan, ulkotarhan pinta-alan, pesäpönttöjen määrän ja orren pituuden.",
  "hens": "Kanojen lukumäärä",
  "resultTitle": "Suositukset",
  "coopArea": "Suoja-alan pinta-ala",
  "runArea": "Ulkotarhan pinta-ala",
  "nestBoxes": "Pesäpönttöjen määrä",
  "perchLength": "Orren pituus",
  "m2Unit": "m²",
  "mUnit": "m",
  "disclaimer": "Suuntaa-antavat suositukset perustuvat hyviin kasvatuskäytäntöihin (n. 3 kanaa/m² suojassa, 2,5 m²/kana ulkotarhassa, 1 pesäpönttö 4 kanaa kohti, 20 cm orresta per kana).",
  "ctaTitle": "Hallinnoi kanalaasi Ma Petite Ferme -sovelluksella",
  "ctaText": "Seuraa eläimiäsi, munantuotantoasi ja päivittäistä toimintaasi helposti yhdessä paikassa.",
  "ctaBtn": "Luo oma farmini ilmaiseksi"
 },
 "hu": {
  "slug": "tyukolketrec-meretu-kalkulator",
  "title": "Tyúkól méret kalkulátor | Ma Petite Ferme",
  "metaDescription": "Számítsd ki ingyenesen a tyúkólad ideális méretét: ólterület, kifutó, fészekfiókok és ülőrúd hossza. Praktikus segítség csirkéid jólétéhez.",
  "h1": "Tyúkól méret kalkulátor",
  "intro": "Add meg a tyúkjaid számát, és azonnal megkapod az ajánlott méreteket: ólterület, kifutó nagysága, fészekfiókok száma és ülőrúd hossza.",
  "hens": "Tyúkok száma",
  "resultTitle": "Ajánlások",
  "coopArea": "Ólterület",
  "runArea": "Kifutó területe",
  "nestBoxes": "Fészekfiókok száma",
  "perchLength": "Ülőrúd hossza",
  "m2Unit": "m²",
  "mUnit": "m",
  "disclaimer": "Tájékoztató jellegű ajánlások, bevált tartási gyakorlatok alapján (kb. 3 tyúk/m² ólban, 2,5 m²/tyúk kifutón, 1 fészekfiók 4 tyúkonként, 20 cm ülőrúd tyúkonként).",
  "ctaTitle": "Kezelje állományát a Ma Petite Ferme segítségével",
  "ctaText": "Kövesse nyomon állatait, a tojástermelést és a napi teendőket egyszerűen, egy helyen.",
  "ctaBtn": "Hozd létre farmodat ingyen"
 },
 "pt": {
  "slug": "calculadora-tamanho-galinheiro",
  "title": "Calculadora de Tamanho de Galinheiro | Ma Petite Ferme",
  "metaDescription": "Calcule gratuitamente o tamanho ideal do seu galinheiro: área do abrigo, área do pátio, número de ninhos e comprimento do poleiro para suas galinhas.",
  "h1": "Calculadora de Tamanho de Galinheiro",
  "intro": "Indique o número de galinhas para obter as dimensões recomendadas: área do abrigo, área do pátio externo, número de ninhos e comprimento do poleiro.",
  "hens": "Número de galinhas",
  "resultTitle": "Recomendações",
  "coopArea": "Área do abrigo",
  "runArea": "Área do pátio externo",
  "nestBoxes": "Número de ninhos",
  "perchLength": "Comprimento do poleiro",
  "m2Unit": "m²",
  "mUnit": "m",
  "disclaimer": "Recomendações indicativas baseadas nas boas práticas de criação (aprox. 3 galinhas/m² de abrigo, 2,5 m²/galinha de pátio externo, 1 ninho para cada 4 galinhas, 20 cm de poleiro por galinha).",
  "ctaTitle": "Gerencie sua criação com a Ma Petite Ferme",
  "ctaText": "Acompanhe seu plantel, as postura e sua produção no dia a dia, de forma simples e prática.",
  "ctaBtn": "Criar minha fazenda gratuitamente"
 },
 "lv": {
  "slug": "vistu-kopsanas-vietas-izmera-kalkulators",
  "title": "Vistubūves izmēra kalkulators | Ma Petite Ferme",
  "metaDescription": "Aprēķiniet bezmaksas ideālo vistubūves izmēru savām vistām: nojumes laukums, pastaigu zona, perēkļu skaits un laktu garums.",
  "h1": "Vistubūves izmēra kalkulators",
  "intro": "Norādiet savu vistu skaitu, lai iegūtu ieteicamos izmērus: nojumes laukumu, pastaigu zonas laukumu, perēkļu skaitu un laktu garumu.",
  "hens": "Vistu skaits",
  "resultTitle": "Ieteikumi",
  "coopArea": "Nojumes laukums",
  "runArea": "Pastaigu zonas laukums",
  "nestBoxes": "Perēkļu skaits",
  "perchLength": "Laktu garums",
  "m2Unit": "m²",
  "mUnit": "m",
  "disclaimer": "Indikatīvi ieteikumi, pamatojoties uz labas audzēšanas praksi (aptuveni 3 vistas/m² nojumē, 2,5 m²/vistai pastaigu zonā, 1 perēklis uz 4 vistām, 20 cm laktu/vistai).",
  "ctaTitle": "Pārvaldiet savu mājputnu audzētavu ar Ma Petite Ferme",
  "ctaText": "Sekojiet savam ganāmpulkam, ološanai un ikdienas produkcijai — vienkārši un ērti.",
  "ctaBtn": "Izveidot savu fermu bez maksas"
 },
 "pl": {
  "slug": "kalkulator-wielkosci-kurnika",
  "title": "Kalkulator wielkości kurnika | Ma Petite Ferme",
  "metaDescription": "Oblicz bezpłatnie idealną wielkość kurnika dla swoich kur: powierzchnia kurnika, wybieg, liczba gniazd i długość grzędy. Szybko i prosto!",
  "h1": "Kalkulator wielkości kurnika",
  "intro": "Podaj liczbę kur, aby uzyskać zalecane wymiary: powierzchnię kurnika, powierzchnię wybiegu, liczbę gniazd i długość grzędy.",
  "hens": "Liczba kur",
  "resultTitle": "Zalecenia",
  "coopArea": "Powierzchnia kurnika",
  "runArea": "Powierzchnia wybiegu",
  "nestBoxes": "Liczba gniazd",
  "perchLength": "Długość grzędy",
  "m2Unit": "m²",
  "mUnit": "m",
  "disclaimer": "Zalecenia orientacyjne oparte na dobrych praktykach hodowlanych (ok. 3 kury/m² kurnika, 2,5 m²/kurę wybiegu, 1 gniazdo na 4 kury, 20 cm grzędy/kurę).",
  "ctaTitle": "Zarządzaj swoim hodowlą z Ma Petite Ferme",
  "ctaText": "Śledź swoje stado, zniesione jaja i codzienną produkcję w prosty i wygodny sposób.",
  "ctaBtn": "Załóż moją fermę bezpłatnie"
 },
 "lt": {
  "slug": "vistu-narvelio-dydzio-skaiciuokle",
  "title": "Vištidės dydžio skaičiuoklė | Ma Petite Ferme",
  "metaDescription": "Apskaičiuokite idealų vištidės dydį nemokamai: pastogės plotas, išėjimo zona, lizdų ir laktos ilgio rekomendacijos jūsų vištoms.",
  "h1": "Vištidės dydžio skaičiuoklė",
  "intro": "Įveskite savo vištų skaičių ir gaukite rekomenduojamus matmenis: pastogės plotą, išėjimo zonos plotą, lizdų skaičių ir laktos ilgį.",
  "hens": "Vištų skaičius",
  "resultTitle": "Rekomendacijos",
  "coopArea": "Pastogės plotas",
  "runArea": "Išėjimo zonos plotas",
  "nestBoxes": "Lizdų skaičius",
  "perchLength": "Laktos ilgis",
  "m2Unit": "m²",
  "mUnit": "m",
  "disclaimer": "Orientacinės rekomendacijos, pagrįstos gerąja auginimo praktika (apie 3 vištos/m² pastogėje, 2,5 m²/višta išėjimo zonoje, 1 lizdas 4 vištoms, 20 cm laktos vienai vištai).",
  "ctaTitle": "Valdykite savo ūkį su Ma Petite Ferme",
  "ctaText": "Stebėkite savo bandą, kiaušinių dėjimą ir gamybą kasdien – paprastai ir patogiai.",
  "ctaBtn": "Kurti savo ūkį nemokamai"
 },
 "ro": {
  "slug": "calculator-dimensiuni-cotet-gaini",
  "title": "Calculator dimensiuni cotet gaini | Ma Petite Ferme",
  "metaDescription": "Calculeaza gratuit dimensiunile ideale pentru cotetul tau: suprafata adapost, curte, numar cuiburi si lungime stinghii pentru gainile tale.",
  "h1": "Calculator dimensiuni cotet pentru gaini",
  "intro": "Introdu numarul de gaini pentru a obtine dimensiunile recomandate: suprafata adapostului, suprafata curtii, numarul de cuiburi si lungimea stinghiilor.",
  "hens": "Numar de gaini",
  "resultTitle": "Recomandari",
  "coopArea": "Suprafata adapostului",
  "runArea": "Suprafata curtii",
  "nestBoxes": "Numar de cuiburi",
  "perchLength": "Lungime stinghii",
  "m2Unit": "m²",
  "mUnit": "m",
  "disclaimer": "Recomandari orientative bazate pe bunele practici de crestere (aprox. 3 gaini/m² adapost, 2,5 m²/gaina curte, 1 cuib la 4 gaini, 20 cm stinghie/gaina).",
  "ctaTitle": "Gestioneaza-ti crescatoria cu Ma Petite Ferme",
  "ctaText": "Urmareste efectivul, ouale si productia zilnica, simplu si rapid.",
  "ctaBtn": "Creeaza-mi ferma gratuit"
 },
 "sk": {
  "slug": "kalkulator-velkosti-kurnika",
  "title": "Kalkulator veľkosti kurníka | Ma Petite Ferme",
  "metaDescription": "Vypočítajte zadarmo ideálnu veľkosť kurníka pre vaše sliepky: plocha prístrešku, výbeh, počet hniezd a dĺžka bidla.",
  "h1": "Kalkulator veľkosti kurníka",
  "intro": "Zadajte počet sliepok a získajte odporúčané rozmery: plochu prístrešku, plochu výbehu, počet hniezd a dĺžku bidla.",
  "hens": "Počet sliepok",
  "resultTitle": "Odporúčania",
  "coopArea": "Plocha prístrešku",
  "runArea": "Plocha výbehu",
  "nestBoxes": "Počet hniezd",
  "perchLength": "Dĺžka bidla",
  "m2Unit": "m²",
  "mUnit": "m",
  "disclaimer": "Orientačné odporúčania založené na osvedčených chovateľských postupoch (cca 3 sliepky/m² prístrešku, 2,5 m²/sliepku výbehu, 1 hniezdo na 4 sliepky, 20 cm bidla/sliepku).",
  "ctaTitle": "Spravujte svoj chov s Ma Petite Ferme",
  "ctaText": "Sledujte svoje stádo, znášku a dennú produkciu jednoducho a prehľadne.",
  "ctaBtn": "Vytvoriť moju farmu zadarmo"
 },
 "cs": {
  "slug": "kalkulator-velikosti-kurnika",
  "title": "Kalkulátor velikosti kurníku | Ma Petite Ferme",
  "metaDescription": "Vypočítejte zdarma ideální velikost kurníku pro vaše slepice: plocha přístřešku, výběhu, počet hnízdišť a délka bidla.",
  "h1": "Kalkulátor velikosti kurníku",
  "intro": "Zadejte počet slepic a získejte doporučené rozměry: plochu přístřešku, plochu výběhu, počet hnízdišť a délku bidla.",
  "hens": "Počet slepic",
  "resultTitle": "Doporučení",
  "coopArea": "Plocha přístřešku",
  "runArea": "Plocha výběhu",
  "nestBoxes": "Počet hnízdišť",
  "perchLength": "Délka bidla",
  "m2Unit": "m²",
  "mUnit": "m",
  "disclaimer": "Orientační doporučení vycházející z osvědčených chovatelských postupů (cca 3 slepice/m² přístřešku, 2,5 m²/slepici výběhu, 1 hnízdiště na 4 slepice, 20 cm bidla/slepici).",
  "ctaTitle": "Spravujte svůj chov s Ma Petite Ferme",
  "ctaText": "Sledujte svá zvířata, snášku a denní produkci jednoduše a přehledně.",
  "ctaBtn": "Vytvořit farmu zdarma"
 },
 "sl": {
  "slug": "kalkulator-velikosti-kokosnjaka",
  "title": "Kalkulator velikosti kokošnjaka | Ma Petite Ferme",
  "metaDescription": "Brezplačno izračunajte idealno velikost kokošnjaka: površina zavetišča, izpust, število gnezdilnic in dolžina počivališča za vaše kokoši.",
  "h1": "Kalkulator velikosti kokošnjaka",
  "intro": "Vnesite število kokoši in pridobite priporočene mere: površina zavetišča, površina izpusta, število gnezdilnic in dolžina počivališča.",
  "hens": "Število kokoši",
  "resultTitle": "Priporočila",
  "coopArea": "Površina zavetišča",
  "runArea": "Površina izpusta",
  "nestBoxes": "Število gnezdilnic",
  "perchLength": "Dolžina počivališča",
  "m2Unit": "m²",
  "mUnit": "m",
  "disclaimer": "Okvirna priporočila, ki temeljijo na dobrih praksah reje (pribl. 3 kokoši/m² zavetišča, 2,5 m²/kokoš izpusta, 1 gnezdilnica za 4 kokoši, 20 cm počivališča/kokoš).",
  "ctaTitle": "Upravljajte svojo rejo z Ma Petite Ferme",
  "ctaText": "Spremljajte svojo živino, nesnost in dnevno proizvodnjo – preprosto in brez zapletov.",
  "ctaBtn": "Ustvarite svojo farmo brezplačno"
 }
};
